import React from 'react';

import { NEFIStepsContext } from 'context/NEFIStepsContext';
import PropTypes from 'prop-types';

// import { NEFormTestingBanner } from 'components/FormHelper/FormTestingBanners/NEFormTestingBanner';
import { NEFIStepsbar } from 'components/NEFIComponents/NEFIStepsbar/NEFIStepsbar';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

import './NEFIStepsContainer.sass';

export const NEFIStepsContainer = ({ children }) => (
  <NEFIStepsContext>
    <div className="nefi-steps-container">
      {/* <NEFormTestingBanner /> */}
      {/* will be added back later */}
      <PageTitleSection title="Registrierung als Fachinteressent" notFramed />

      <NEFIStepsbar />
      {children}
    </div>
  </NEFIStepsContext>
);

NEFIStepsContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
